import slideLogo1 from '../../assets/images/icon/star-icon.png';
import { Helmet } from 'react-helmet';
export default function SlidingText() {
const phrases = ["Magic of Events", "Celebrate Life"];
  return (
    <>
    <Helmet>
  <link rel="preload" as="image" href={slideLogo1} />
</Helmet>
      {/* Sliding Text Start */}
      <section className="sliding-text-one">
          <div className="sliding-text-one__wrap">
        <ul className="sliding-text__list marquee_mode">
  {Array.from({ length: 6 }).map((_, index) => (
    <li key={index}>
      <h2 className="sliding-text__title" data-hover={phrases[index % 2]}>
        {phrases[index % 2]} <img src={slideLogo1} alt="Star Icon" />
      </h2>
    </li>
  ))}
</ul>
          </div>
      </section>
      {/* Sliding Text End */}
    </>
  );
}
